package org.mkui.interaction

/**
 * Interaction mode.
 */
enum class InteractionMode {
    /**
     * Selection mode.
     */
    Selection, Filter, Toggle, DoNothing
}